import { MediaFieldFormSubmission } from '../models';

export const MobileSignatureField = MediaFieldFormSubmission.extend({
    get_submission_value: function () {
        return this.get('value');
    }
});
